/**
 * Removes undefined properties from an object recursively
 * @param obj Object to clean
 * @returns New object with undefined properties removed
 */
export function removeUndefined<T extends object>(obj: T): T {
  const result: unknown = {};

  Object.entries(obj).forEach(([key, value]) => {
    if (value === undefined) return;

    if (value && typeof value === 'object' && !Array.isArray(value)) {
      result[key] = removeUndefined(value);
    } else {
      result[key] = value;
    }
  });

  return result as T;
}